import React from 'react';
import { MdCheck } from 'react-icons/md';
import { DropdownItemProps } from '../types';

const DropdownItem: React.FC<DropdownItemProps> = ({
  item,
  isSelected,
  onClick,
  theme,
  displayName,
}) => {
  return (
    <div
      className={`px-4 py-2 cursor-pointer flex items-center justify-between transition-colors ${
        isSelected ? 'bg-orange-50' : 'hover:bg-orange-50'
      }`}
      onClick={onClick}
    >
      <span className="text-gray-700 truncate">{displayName || item.name}</span>
      {isSelected && (
        <MdCheck className="w-4 h-4 text-orange-500 flex-shrink-0 ml-2" />
      )}
    </div>
  );
};

export default DropdownItem;
